module.exports = __webpack_public_path__ + "static/media/atelier-de-maquilhagem@2x.60617af9.jpg";